(function () {
    'use strict';

    angular
        .module('core.services')
        .service('PhoneTypeService', PhoneTypeService)

    /** @ngInject */
    function PhoneTypeService(HttpService) {
        const PhoneTypeService = {
            getAll: getAll
        }

        return PhoneTypeService;

        function getAll() {
            return HttpService.get('/phones/types');
        }
    }
}());